module.exports = __webpack_public_path__ + "img/3f_l_newtokyo@2x.1349e977.png";